import { render, staticRenderFns } from "./basicSetting.vue?vue&type=template&id=fcad8d3c"
import script from "./basicSetting.vue?vue&type=script&lang=js"
export * from "./basicSetting.vue?vue&type=script&lang=js"
import style0 from "./basicSetting.vue?vue&type=style&index=0&id=fcad8d3c&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcad8d3c')) {
      api.createRecord('fcad8d3c', component.options)
    } else {
      api.reload('fcad8d3c', component.options)
    }
    module.hot.accept("./basicSetting.vue?vue&type=template&id=fcad8d3c", function () {
      api.rerender('fcad8d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/basicSetting.vue"
export default component.exports